export default function() {

    var infoBtns = document.getElementsByClassName("member__more");
    for (var i = 0; i < infoBtns.length; i++) {
        infoBtns[i].addEventListener("click", function(e) {
            e.preventDefault();
            const info = e.currentTarget.parentNode;
            info.classList.toggle("infoOpen");
        })
    }

}
